export default __webpack_public_path__ + "static/media/tiffany-brand-sq.73c92ba7.jpg";